import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/locale'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

function setI18nLanguage (lang, axios) {
  if (i18n.locale !== lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
  }
  return Promise.resolve(lang)
}

export function initI18N (router, axios) {
  router.beforeEach((to, from, next) => {
    const lang = to.query.lang || 'en'
    setI18nLanguage(lang.toLowerCase(), axios).then(() => { next() })
  })
}

export default i18n
